import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Auth.css';
import { toast } from 'react-toastify';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import "react-toastify/dist/ReactToastify.css";
import ClipLoader from 'react-spinners/ClipLoader';
import { BASE_URL, register } from '../../Services/Services';
import axios from 'axios';
import { GoogleLogin } from '@react-oauth/google';


const Register = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [googleAuthLoading, setGoogleAuthLoading] = useState(false);
  const [data, setData] = useState({
    password: '',
    email: '',
    fullName: '',
    phoneNumber: '',
    userType: 'Instructor'
  });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;


  const handleRegister = async (e) => {
    e.preventDefault();

    toast.dismiss();
    if (!isChecked) {
      toast.error('Please agree to the terms and privacy policy before proceeding.');
      return;
    }


    if (!data.fullName.trim()) {
      toast.error('Full Name cannot be empty', { autoClose: 3000 });
      return;
    }

    if (!emailRegex.test(data.email)) {
      toast.error('Invalid email format', { autoClose: 3000 });
      return;
    }

    if (!passwordRegex.test(data.password)) {
      toast.error('Password must be at least 8 characters long, including 1 uppercase letter and 1 symbol', { autoClose: 3000 });
      return;
    }

    setLoading(true);
    const toastId = toast.success('Please wait while we verify your details..', {
      autoClose: false,
    });
    try {
      const response = await register(data);
      toast.dismiss(toastId);

      toast.dismiss();
      if (response?.status === 201) {
        toast.success("Registered successfully!", { autoClose: 3000 });
        navigate('/login');
      } else {
        toast.success(response?.data?.message);

      }
    } catch (error) {
      toast.dismiss(toastId);

      toast.dismiss();
      if (error?.response?.status === 503) {
        toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
      }
      if (error?.response?.status === 409) {
        toast.error("User already exists. Please Login!", { autoClose: 3000 });
      }
      else {
        toast.error(error.response?.data || 'Network error. Please check your connection and try again.');
      }
    } finally {
      setLoading(false);
      toast.dismiss(toastId);

    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  }


  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (userId) {
      navigate('/');
    }
  }, [navigate]);


  const handleGoogleLogin = async (response) => {
    const token = response.credential;
    toast.dismiss();
    try {
      setGoogleAuthLoading(true);
      const response = await axios.post(`${BASE_URL}/google/login`, { token: token, userType: "Instructor" });
      if (response?.status === 200) {
        toast.success("Logged In successfully!", { autoClose: 3000 });
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('fullName', response.data.fullname);
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('userId', response.data.userId);
        localStorage.setItem('userType', response.data.userType);
        localStorage.setItem('profilePictureUrl', response.data.profilePictureUrl);
        localStorage.setItem('phoneNumber', response?.data?.phoneNumber || "Click 'Update Mobile Number' to add your number, as it's not available");


        navigate('/');
      } else {
        toast.success(response?.data?.message);
      }

    } catch (error) {
      toast.dismiss();
      if (error?.response?.status === 503) {
        toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
      } else {
        toast.error('There was an issue connecting. Please try again, or use normal login/registration.');
      }
    } finally {
      setGoogleAuthLoading(false);
    }
  };


  const handleGoogleLoginFailure = (error) => {
    console.error('Google Login Failed:', error);
    toast.error('Google login failed. Please try again.', { autoClose: 3000 });
  };



  if (googleAuthLoading) {
    return <div className='loading-container'><div className="loading-overlay">
      <ClipLoader color="black" loading={googleAuthLoading} size={30} />
    </div></div>;
  }


  return (
    <div className='main-login-container'>
      <div className="login-container">
        <div className="login-form">
          <h2>Create An Instructor Account</h2>
          <form onSubmit={handleRegister}>

            <div className="password-input-container">
              <input
                type="text"
                placeholder="Full Name"
                value={data.fullName}
                onChange={(e) => setData({ ...data, fullName: e.target.value })}
                required
              />
            </div>
            <div className="password-input-container">
              <input
                type="text"
                placeholder="Email"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value.toLowerCase() })}
                required
              />
            </div>

            <div className="password-input-container">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={data.password}
                onChange={(e) => setData({ ...data, password: e.target.value })}
                required
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>

            <div className="checkbox-container">
              <label>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                I agree to the <a href="/terms-conditions" target="_blank">Terms and Conditions</a> and <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
              </label>
            </div>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? <ClipLoader color="#fff" loading={loading} size={30} /> : "Register"}
            </button>

          </form>
          <div className="options">
            <a href="/login">Already have an account? Log In</a>
          </div>

          <div className="divider">
            <hr />
            <span>or</span>
            <hr />
          </div>
          <div className="social-icons">
            <div className="google-icon">
              <GoogleLogin
                onSuccess={handleGoogleLogin}
                onFailure={handleGoogleLoginFailure}
                scope="profile email"
                responseType="token id_token"
                useOneTap
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
